import React, { Component } from 'react';
import { ThemeProvider } from '@material-ui/styles';
import Theme from './utils/theme';
import { Dashboard } from './dashboard/Dashboard';
import LandingPage from './components/landing-page/LandingPage';
import HelmetHead from './components/helmet-head/HelmetHead';

import './App.scss';

export default class App extends Component {
    constructor(props) {
        super(props);

        this.dataAvailable = this.dataAvailable.bind(this);
        this.clearData = this.clearData.bind(this);
        this.state = {
            data: null
        };
    }

    dataAvailable(data) {
        this.setState({ data });
    }

    render() {
        return (
            <ThemeProvider theme={Theme}>
                <div className="App">
                    <HelmetHead />

                    {this.state.data ? (
                        <Dashboard data={this.state.data} dataCleared={this.clearData} />
                    ) : (
                            <LandingPage uploadDataAvailable={this.dataAvailable} />
                        )}
                </div>
            </ThemeProvider>
        );
    }

    clearData() {
        this.setState({
            data: null
        });
    }
}
